import { render, staticRenderFns } from "./ToggleSwitch.vue?vue&type=template&id=1b4ad1d8&scoped=true"
import script from "./ToggleSwitch.vue?vue&type=script&lang=js"
export * from "./ToggleSwitch.vue?vue&type=script&lang=js"
import style0 from "./ToggleSwitch.vue?vue&type=style&index=0&id=1b4ad1d8&prod&lang=css"
import style1 from "./ToggleSwitch.vue?vue&type=style&index=1&id=1b4ad1d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_cache-loader@4.1.0_webpack@4.47.0__css-load_0b7ff5153dda3b71f22745c8daebd203/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4ad1d8",
  null
  
)

export default component.exports